import { ModalHeader } from '@chakra-ui/react';
import { NoticeIcon } from '../icons/notice-icon';
import { RiskScoreInfo } from '../modals/risk-score/risk-score-info';
import { oldTheme } from '../shared/old-styles';
import { MetricTitle } from '../shared/overview-metric-title';
import { InfoIconProps } from './info-icons-general';
import { MetricInfoIcon } from './metric-info-icon';

export function RiskScoreInfoIcon(props: InfoIconProps) {
  const modalHeader = (
    <ModalHeader style={{ marginLeft: '-20px' }}>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <NoticeIcon />
        <div style={{ paddingLeft: oldTheme.spacing.xs }}>
          <MetricTitle noBold noColor />
        </div>
      </div>
    </ModalHeader>
  );

  const modalContent = (
    <>
      {modalHeader}
      <RiskScoreInfo />
    </>
  );

  return <MetricInfoIcon {...props} modalContent={modalContent} />;
}
